import { OverallTrends, OverallTrendsResponse } from "@/features/home/types";

export const processOverallTrends = (data: OverallTrendsResponse): OverallTrends => {
  const processedData = {
    labels: [],
    revenue: [],
    impression: [],
  } as OverallTrends;
  data.overallTrends.forEach(value => {
    processedData.labels.push(value.date);
    if (value.revenue === null) processedData.revenue.push(value.revenue);
    else processedData.revenue.push(Math.floor(value.revenue));
    processedData.impression.push(value.impression);
  });
  return processedData;
};
